// src/assets/icons/icon-youtube-logo.tsx
import { jsx } from "react/jsx-runtime";
var IconYoutubeLogo = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    width: "1em",
    height: "1em",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M500 183.85A108.85 108.85 0 0 0 391.12 75H108.85A108.85 108.85 0 0 0 0 183.85v132.3A108.85 108.85 0 0 0 108.85 425h282.3A108.85 108.85 0 0 0 500 316.15Zm-178.12 72.83L209.3 318.41c-5 2.66-9.3-.89-9.3-6.46V185.14c0-5.64 4.52-9.15 9.45-6.39l113.35 65a7.46 7.46 0 0 1-.92 12.9Z" })
  }
);
export {
  IconYoutubeLogo
};
